import { render, staticRenderFns } from "./UtenteRoles.vue?vue&type=template&id=27d2fbfc&"
import script from "./UtenteRoles.vue?vue&type=script&lang=ts&"
export * from "./UtenteRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports